<template>
	<div class="graph">
		<ScaleTabs
			v-bind:scale="scale"
			:scales="scales"
			@change="setScale"></ScaleTabs>
		<DatePicker
			v-bind:date="date"
			v-bind:startDate="startDate"
			@previous="previous"
			@next="next"></DatePicker>
		<BarGraph2D
			v-bind:data="symptomTimes"
			v-bind:startDate="startDate"
			v-bind:date="date"
			v-bind:interval="interval"
			v-bind:binWidth="binWidth">
		</BarGraph2D>
	</div>
</template>

<script>
import Graph from './index'
import BarGraph2D from '../BarGraph2D'

export default {
	name: 'symptom-graph',
	extends: Graph,

	computed: {
		/**
		 * @function 	symptomOccurrences
		 * @desc 		To get the timestamp when the symptom event occured with key as 'occurence'
		 */
		symptomTimes() {
			return this.data.map((symptom) => ({ time: symptom.time, value: 1 }))
		}
	}
}
</script>
